import type { Consent } from './types';

export const NO_CONSENT: Consent = {
  newsEmail: false,
  newsPhone: false,
  offersEmail: false,
  offersPhone: false,
  partnersEmail: false,
  partnersPhone: false,
  phone: null,
};

export const wantsPhone = (c: Consent) => c.newsPhone || c.offersPhone || c.partnersPhone;

/** Same rule as the API: DDD + number, 10 to 15 digits. */
export const phoneValid = (phone: string | null | undefined) =>
  /^\d{10,15}$/.test((phone ?? '').replace(/\D/g, ''));
